/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { BasicInfoVO } from './BasicInfoVO';
import { CabinUpgradePreferenceInfoVO } from './CabinUpgradePreferenceInfoVO';
import { CompanionInfoVO } from './CompanionInfoVO';
import { CorporateAffiliationProfileInfo } from './CorporateAffiliationProfileInfo';
import { CorporateAgreementInfoVO } from './CorporateAgreementInfoVO';
import { EmailAddressInfoVO } from './EmailAddressInfoVO';
import { EmergencyContactInfoVO } from './EmergencyContactInfoVO';
import { FormOfPaymentInfoVO } from './FormOfPaymentInfoVO';
import { LoyaltyAccountInfoVO } from './LoyaltyAccountInfoVO';
import { LoyaltyMemberCorporateAgreement } from './LoyaltyMemberCorporateAgreement';
import { MailingAddressInfoVO } from './MailingAddressInfoVO';
import { PartnerProgramInfoVO } from './PartnerProgramInfoVO';
import { PhoneInfoVO } from './PhoneInfoVO';
import { SalesAffiliationInfoVO } from './SalesAffiliationInfoVO';
import { SavedTripInfoVO } from './SavedTripInfoVO';
import { SecureFlightPassengerInfoVO } from './SecureFlightPassengerInfoVO';

export interface CustomerInfoVO {
  basicInfo?: BasicInfoVO;
  /**
   * list of cabin upgrade preferences from customer's profile
   */
  cabinUpgradePreferenceList?: Array<CabinUpgradePreferenceInfoVO>;
  /**
   * list of car loyalty program from customer's profile
   */
  carLoyaltyProgramList?: Array<PartnerProgramInfoVO>;
  /**
   * list of companions from customer's profile
   */
  companionList?: Array<CompanionInfoVO>;
  /**
   * list of corporate affiliation profile info of the customer
   */
  corpAffiliationProfileList?: Array<CorporateAffiliationProfileInfo>;
  /**
   * list of corporate agreements from customer's profile
   */
  corporateAgreementInfoVOList?: Array<CorporateAgreementInfoVO>;
  /**
   * list of email addresses from customer's profile
   */
  emailAddressList?: Array<EmailAddressInfoVO>;
  emergencyContact?: EmergencyContactInfoVO;
  /**
   * list of frequent flyer program info from customer's profile
   */
  frequentFlyerProgramList?: Array<PartnerProgramInfoVO>;
  loyaltyAccount?: LoyaltyAccountInfoVO;
  /**
   * list of corporate agreements list of the customer
   */
  loyaltyMemberCorporateAgreementList?: Array<LoyaltyMemberCorporateAgreement>;
  /**
   * list of mailing addresses from customer's profile
   */
  mailingAddressList?: Array<MailingAddressInfoVO>;
  /**
   * list of phones from customer's profile
   */
  phoneList?: Array<PhoneInfoVO>;
  /**
   * list of sales affiliations from customer's profile
   */
  salesAffiliationList?: Array<SalesAffiliationInfoVO>;
  /**
   * list of saved trips from customer's profile
   */
  savedTripList?: Array<SavedTripInfoVO>;
  secureFlightPassengerData?: SecureFlightPassengerInfoVO;
  /**
   * list of stored FOP from customer's profile
   */
  storedFOPList?: Array<FormOfPaymentInfoVO>;
}
